<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>
          <v-container>
            <v-data-table
              :headers="headers"
              :items="systemsStatuses"
              class="elevation-1"
            >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.systemName }}</td>
              <td>
                  <v-btn v-if="props.item.systemStatus === 'UP'"  color="primary"> {{ props.item.systemStatus }} </v-btn>
                   <v-btn v-if="props.item.systemStatus === 'DOWN'"  color="red"> {{ props.item.systemStatus }} </v-btn>
              </td>
            </template>
            <template slot="no-data">
              <p> No data Found </p>
              <v-btn color="primary" @click="getSystemStatus">Reload</v-btn>
            </template>
           </v-data-table>

          </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'viewsystemstatus',
  data: function() {
    return {
      headers: [
        {
          text: 'System',
          value: 'systemName'
        },
        { text: 'Status', value: 'systemStatus' }
      ],
      message: '',
      error: '',
      systemsStatuses: []
    }
  },
  mounted () {
    this.getSystemStatus()
  },
  methods: {
    getSystemStatus () {
      var url = config.serverURI + '/systemstatus/database'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.systemsStatuses = response.data
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.systemsStatuses
    }
  }
}

</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// systemstatus.vue?3aaf5724